<template>
  <div class="main">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    this.initShareConfig();
  },
  methods: {
    initShareConfig() {
      let CP = window.CP;
      CP.setShare({
        completed: function (data) {
          // data > {success:'1'}
        },
        cpIncompatible: function () {
          CP.tools.writelog("", "此环境不支持此方法");
        },
        title: "温岭少年警校线上学习平台",
        shareTo: "Timeline",
        link: window.location.origin + '/shaonianjingxiao/index',
        imgUrl:
          "https://i.tmuyun.com/webpic/W0202407/W020240722/W020240722663416720845.jpg",
        shareSummary: "涨知识，赚学分",
        id: "",
        type: "",
        datatype: "",
        dataUrl: "",
        shareUrlScheme: "",
        success: function () {
          CP.tools.writelog("set_share", "分享成功");
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
  }
</style>